/**
 *
 * Asynchronously loads the component for Representative Users
 *
 */

import loadable from '../../utils/loadable';

export default loadable(() => import('./index'));
